import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import CaseDetail from "@/pages/CaseDetail";
import Cases from "@/pages/Cases";
import Dashboard from "@/pages/Dashboard";
import Kpi from "@/pages/Kpi";
import Login from "@/pages/Login";
import Logs from "@/pages/Logs";
import NewCase from "@/pages/NewCase";
import Users from "@/pages/Users";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background" data-testid="app-loading">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-delta-navy border-t-transparent" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RequireRole({ roles, children }) {
  const { user } = useAuth();
  if (!roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/cases" element={<Cases />} />
              <Route path="/cases/new" element={<NewCase />} />
              <Route path="/cases/:id" element={<CaseDetail />} />
              <Route path="/kpi" element={<RequireRole roles={["super_admin", "admin", "lawyer"]}><Kpi /></RequireRole>} />
              <Route path="/logs" element={<RequireRole roles={["super_admin", "admin", "lawyer"]}><Logs /></RequireRole>} />
              <Route path="/users" element={<RequireRole roles={["super_admin", "admin"]}><Users /></RequireRole>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
